import PasswordResetBody from 'components/PasswordComponents/PasswordResetComponents/PasswordResetBody/PasswordResetBody';
import AuthHeader from 'components/common/AuthHeader';
import React from 'react';

const PasswordReset = () => {
  return (
    <>
      {/* -------- header ------------ */}
      <AuthHeader />

      {/* ---------- body --------- */}
      <PasswordResetBody />
    </>
  );
};

export default PasswordReset;
